import Swiper from 'swiper/bundle';

jQuery(document).ready(function () {
    //initBrowserCheck();
    showMenu();
    setupSubMenu();
    showFixedNav();
    sponsorSlider();
    mobileNavigation();
    loadMoreNews();
    imagesCarouselSlider();
    RaceCountdown();
    loadEvents();


});


function initBrowserCheck() {
    function isIE() {
        ua = navigator.userAgent;
        /* MSIE used to detect old browsers and Trident used to newer ones*/
        var is_ie = ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;

        return is_ie;
    }

    /* Create an alert to show if the browser is IE or not */
    if (isIE()) {
        jQuery('.ie-check').show();
    }
}



function showMenu() {
    $(".burger-menu, .close-menu, .menu-overlay").click(function () {
        $(".svl-menu-container, .menu-overlay").toggleClass("nav-open");
    });

    $(".svl-main-menu a").click(function () {
        $(".svl-menu-container, .menu-overlay").removeClass("nav-open");
    });

    $(".open-menu-link").click(function (e) {
        e.preventDefault();

        const target = document.querySelector("#kontakt");

        if (target) {
            target.scrollIntoView({behavior: "smooth"});

            setTimeout(function () {
                $(".svl-menu-container, .menu-overlay").removeClass("nav-open");
            }, 300);
        }
    });
}


function setupSubMenu() {
    if (window.innerWidth > 768) {
        $('.menu-item-has-children').each(function () {
            let menuItem = $(this);
            let subMenu = menuItem.find('.sub-menu');
            let delayTimer;

            menuItem.on('mouseenter', function () {
                clearTimeout(delayTimer);
                subMenu.addClass('visible-sub-menu');
            });

            menuItem.on('mouseleave', function () {
                delayTimer = setTimeout(function () {
                    subMenu.removeClass('visible-sub-menu');
                }, 300);
            });

            menuItem.children('a').removeAttr('href');
        });
    }
}


function mobileNavigation() {
    $('.menu-item-has-children > a').click(function (e) {
        if (window.innerWidth < 768) {
            e.preventDefault();

            // Close any open sub-menu
            $('.menu-item-has-children > a').not(this).siblings('.sub-menu').slideUp();
            $('.menu-item-has-children > a').not(this).removeClass('expanded');

            // Toggle the sub-menu and update the 'expanded' class
            $(this).siblings('.sub-menu').slideToggle();
            $(this).toggleClass('expanded');
        }
    });
}


function showFixedNav() {
    $(document).ready(function () {
        let fixedHeader = $('.fixed-home-header');
        let fpContainer = $('.fp-container');

        if (fpContainer.length > 0) {
            $(window).scroll(function () {
                let scrollPosition = $(window).scrollTop();
                let fpContainerOffset = fpContainer.offset().top;

                fixedHeader.toggleClass('visible', scrollPosition >= fpContainerOffset);
            });
        }
    });
}

function sponsorSlider() {
    $('.sponsor-logo-container').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1040,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    });
}

function loadMoreNews() {
    let page = 2;
    $('.more-news-btn a').on('click', function (e) {
        e.preventDefault();
        let offset = $('.individual-news').length;

        let data = {
            'action': 'load_more_news',
            'page': page,
            'offset': offset
        };

        $.ajax({
            url: ajax.url,
            type: 'post',
            data: data,
            success: function (response) {
                $('.fp-news-wrapper').append(response);
                if ($(response).find('.individual-news').length === 0) {
                    $('.more-news-btn').hide();
                } else {
                    page++;
                }
            }
        });
    });
}




function imagesCarouselSlider() {
    var swiper = new Swiper('.images-carousel-swiper', {
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        speed: 600,
        spaceBetween: 10,
        preventClicks: true,
        effect: 'slide',

        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },

        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },


        breakpoints: {
            768: {
                slidesPerView: 2,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 50,
                    depth: 150,
                    modifier: 1,
                    slideShadows: false
                }
            }
        }
    });
}





function RaceCountdown() {
    function startCountdown(timestamp) {
        function updateCountdown() {
            const now = Math.floor(Date.now() / 1000);
            const distance = timestamp - now;

            if (distance <= 0) {
                $('#rc-days, #rc-hours, #rc-minutes, #rc-seconds, #rc-days-mobile, #rc-hours-mobile, #rc-minutes-mobile, #rc-seconds-mobile')
                    .text('00');
                $('#race-message').text('Return 0').show();
                loadNextRace();
                clearInterval(interval);
                return;
            }

            const days = Math.floor(distance / (60 * 60 * 24));
            const hours = Math.floor((distance % (60 * 60 * 24)) / (60 * 60));
            const minutes = Math.floor((distance % (60 * 60)) / 60);
            const seconds = Math.floor(distance % 60);

            const d = String(days).padStart(2, '0');
            const h = String(hours).padStart(2, '0');
            const m = String(minutes).padStart(2, '0');
            const s = String(seconds).padStart(2, '0');

            // Desktop
            $('#rc-days').text(d);
            $('#rc-hours').text(h);
            $('#rc-minutes').text(m);
            $('#rc-seconds').text(s);

            // Mobile
            $('#rc-days-mobile').text(d);
            $('#rc-hours-mobile').text(h);
            $('#rc-minutes-mobile').text(m);
            $('#rc-seconds-mobile').text(s);
        }

        updateCountdown();
        const interval = setInterval(updateCountdown, 1000);
    }

    function loadNextRace() {
        $.post(ajax.url, {action: 'load_next_event_timestamp'}, function (response) {
            if (response.success && response.data.timestamp) {
                const newTimestamp = response.data.timestamp;
                $('#race-countdown, #race-countdown-mobile').attr('data-timestamp', newTimestamp);
                $('#race-message').hide();
                startCountdown(parseInt(newTimestamp));
            } else {
                $('#race-message').text('Keine weiteren Rennen verfügbar.').show();
            }
        });
    }

    const initialTimestamp = parseInt($('#race-countdown').data('timestamp') || $('#race-countdown-mobile').data('timestamp'));
    if (initialTimestamp) {
        startCountdown(initialTimestamp);
    }
}


function loadEvents() {
    jQuery(document).ready(function ($) {
        function loadEvents(filter) {
            $.post(ajax.url, {action: 'load_events', filter: filter}, function (response) {
                $('#event-list').html(response);
            });
        }


        loadEvents('rennen');

        $('.filter-button').click(function () {
            $('.filter-button').removeClass('active');
            $(this).addClass('active');
            loadEvents($(this).data('filter'));
        });
    });

}

// --- MEINE ERFOLGE ---
jQuery(document).ready(function ($) {

    function loadSuccess(filter) {
        $.post(ajax.url, { action: 'load_success', filter: filter }, function (response) {
            $('#erfolge-list').html(response);

            // Titel dynamisch ändern
            if (filter === 'renn') {
                $('#erfolge-title').text('Kart-Rennsport');
            } else {
                $('#erfolge-title').text('Kartslalom');
            }
        });
    }

    // Initial: Kart-Rennsport laden
    loadSuccess('slalom');

    // Klicklogik nur für Erfolge-Buttons
    $('.filter-button-erfolge').on('click', function () {
        $('.filter-button-erfolge').removeClass('active');
        $(this).addClass('active');
        loadSuccess($(this).data('filter'));
    });

});
